'use client';

import { API_URLS } from '$constants/apis';
import { ResetCaseHistoryAction } from '$context/global-context/reducers/case-history/caseHistory.types';
import useGlobalContext from '$hooks/use-global-context';
import useLocale from '$hooks/use-locale';
import { DASHBOARD } from '$locale/constants';
import { DFGModal, Loader } from '@brahma/components';
import { useFetch } from '@brahma/hooks';
import { interpolateString } from '@brahma/utils';
import type { CaseHistoryTimelineResponse, IBFFResponse } from '@dfg/brahma-types';
import React, { useEffect } from 'react';
import { CaseHistoryTimeline } from './caseHistoryTimeline';
const CaseHistoryModal = () => {
  const {
    state: {
      caseHistoryModal: {
        isModalOpen,
        caseId,
        entityId
      }
    },
    dispatch
  } = useGlobalContext();
  const {
    t
  } = useLocale(DASHBOARD);
  const {
    data: caseHistoryData,
    loading: isLoadingCaseHistoryData,
    fetch: fetchCaseHistoryData
  } = useFetch<IBFFResponse<CaseHistoryTimelineResponse>>({
    url: interpolateString(API_URLS.getCaseHistoryTimeline, {
      caseId: caseId ?? '',
      entityId: entityId ?? ''
    })
  }, false);
  const closeModal = () => {
    dispatch(ResetCaseHistoryAction);
  };
  useEffect(() => {
    if (isModalOpen && (caseId || entityId)) {
      fetchCaseHistoryData();
    }
  }, [caseId, entityId]);
  return <>
      <Loader show={isLoadingCaseHistoryData} data-sentry-element="Loader" data-sentry-source-file="caseHistoryModal.tsx" />
      <DFGModal show={isModalOpen && !isLoadingCaseHistoryData} header={{
      show: true,
      title: t('caseHistory.heading'),
      description: t('caseHistory.subHeading'),
      visibleDivider: true
    }} footer={{
      show: false
    }} onBackdropClick={closeModal} data-sentry-element="DFGModal" data-sentry-source-file="caseHistoryModal.tsx">
        <CaseHistoryTimeline data={caseHistoryData?.data} data-sentry-element="CaseHistoryTimeline" data-sentry-source-file="caseHistoryModal.tsx" />
      </DFGModal>
    </>;
};
export default CaseHistoryModal;